import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { dripKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useActivateDrip = () => {
    const additional = useQueryRequestParams();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body) => axios.post(markUrl('drips/activate/'), body, additional),
        onSuccess: (response) => {
            const id = response.data.drip_id;
            queryClient.setQueryData(dripKeys.detail(id), response);
            queryClient.invalidateQueries({ queryKey: dripKeys.detailRoot(id) });
            queryClient.invalidateQueries({ queryKey: dripKeys.list() });
            queryClient.invalidateQueries({ queryKey: dripKeys.validate(id) });
            queryClient.invalidateQueries({ queryKey: dripKeys.versionsRoot(id) });
            queryClient.invalidateQueries({ queryKey: dripKeys.statsRoot(id) });
        }
    });
};
export default useActivateDrip;
